import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { theme } from '../config/theme';
import Location from '../components/Location';
import Footer from '../components/Footer';

const PageContainer = styled.div`
  padding-top: var(--nav-height, 128px); /* Dynamic navigation height */
`;

const Banner = styled(motion.section)`
  background-color: ${theme.colors.primary.background};
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${theme.spacing.lg} ${theme.spacing.sectionPadding.horizontal} ${theme.spacing.xs};
`;

const BannerContent = styled.div`
  max-width: 800px;
  text-align: center;
  z-index: 2;
`;

const LocationWrapper = styled.div`
  & > section {
    padding-top: ${theme.spacing.lg};
  }
`;

const Title = styled(motion.h1)`
  font-family: ${theme.typography.primary.fontFamily};
  font-size: ${theme.typography.primary.largeHeading.fontSize};
  font-weight: ${theme.typography.primary.largeHeading.fontWeight};
  color: ${theme.colors.primary.text};
  margin-bottom: ${theme.spacing.lg};
  letter-spacing: 0.02em;

  @media (max-width: ${theme.breakpoints.tablet}) {
    font-size: 2.5rem;
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: 2rem;
  }
`;


const LocationPage = () => {
  const bannerVariants = {
    hidden: { opacity: 0, y: theme.animations.moveMedium },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: theme.animations.medium,
        ease: 'easeOut',
        staggerChildren: theme.animations.staggerFast,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: theme.animations.moveSmall },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: theme.animations.fast,
        ease: 'easeOut',
      },
    },
  };

  return (
    <PageContainer>
      <Banner
        initial="hidden"
        animate="visible"
        variants={bannerVariants}
      >
        <BannerContent>
          <Title variants={itemVariants}>
            Find <span style={{ color: theme.colors.accent.main }}>Us</span>
          </Title>
        </BannerContent>
      </Banner>

      <LocationWrapper>
        <Location />
      </LocationWrapper>
      
      <Footer />
    </PageContainer>
  );
};

export default LocationPage;